//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    constants: {
        eventKeys: [
            'caseStart',
            'createdVehicle',
            'syncError',
            'expiredCarIns',
        ],
    },

    data() {
        return {
            eventColumns: [
                { name: 'key', label: 'Key', field: 'key', sortable: true, align: 'left' },
                { name: 'item', label: 'Item', field: this.getItemCellValue, sortable: true, align: 'left', autoWidth: true },
                { name: 'timestamp', label: 'Time', field: 'timestamp', format: this.formatSecsLeft, sortable: true, align: 'left' },
            ],
            alertColumns: [
                { name: 'key', label: 'Key', field: 'key', sortable: true, align: 'left', cellType: 'small' },
                { name: 'item', label: 'Item', field: this.getItemCellValue, sortable: true, align: 'left', cellType: 'small', autoWidth: true },
                { name: 'rank', label: 'Rank', field: 'rank', sortable: true, align: 'left', cellType: 'small', autoWidth: true },
                { name: 'text', label: 'Text', field: 'text', sortable: true, align: 'left', cellType: 'small' },
                { name: 'offset', label: 'Offset', field: 'offset', sortable: true, align: 'left', cellType: 'small', autoWidth: true },
                { name: 'dismiss' },
            ],
            now: Date.now(),
            isLoaded: false,
            autoFetch: true,
            events: [],
            alerts: [],
            newEvent: {
                key: 'expiredCarIns',
                itemId: 1,
                secs: 16,
            },
        };
    },

    computed: {
        users() {
            return $.users.filter(u => ['tech', 'manager'].includes(u.role));
        },
    },

    methods: {
        formatSecsLeft(timestamp) {
            return dayjs(timestamp).diff(dayjs(), 'seconds');
        },
        formatTime(timestamp) {
            return dayjs(timestamp).format('HH:mm:ss');
        },
        getItemCellValue(row) {
            return `${row.collName ? row.collName[0].toUpperCase() : ''}${row.itemId ?? ''}`;
        },
        async queueNow({ key, itemId }) {
            await this.queueLater({ key, itemId });
        },
        async queueLater({ key, itemId, secs = 0 }) {
            await axios.post('/queue', { key, itemId, timestamp: Date.now() + secs * 1000 });
        },
        async queueRemove({ key, itemId }) {
            await axios.delete('/queue', { params: { key, itemId } });
        },
        async dismissAlert({ key, itemId, userId }) {
            await axios.delete('/alerts', { params: { key, itemId, userId } });
        },
        async fetchData() {
            try {
                this.events = (await axios('/events')).data;
                this.alerts = (await axios('/alerts')).data;
            } catch (err) {}

            if (this.autoFetch) {
                await $.delay(100);

                this.fetchData();
            }
        },
    },

    @cancellableFetch
    async mounted() {
        await $.actualizeAndFetch('users');

        await this.fetchData();

        this.isLoaded = true;
    },
};
